<template>
	<div class="layout-center-container layout-footer-wrap">
		<img
			src="@/assets/images/mini_logo.png"
			alt=""
			class="layout-footer-logo"
			:style="{
				'transform': `scale(${scale})`,
				'transform-origin': '0 0'
			}"
			@click="goAiditeIndex"
		/>
		<div
			class="layout-footer-item"
			v-for="(item, index) in MENU()"
			:key="index"
			:style="{
				'transform': `scale(${scale})`,
				'transform-origin': '0 0'
			}"
		>
			<div class="b-flex-c cursor-pointer" @click="goMenu(item.name)">
				<c-svg-icons
					:name="footerExpand[item.expand] ? 'icon_reduce' : 'icon_add'"
					size="16"
					@click.stop="footerExpand[item.expand] = !footerExpand[item.expand]"
					class="mr-6"
					v-if="item.children"
				/>
				<div class="layout-footer-level--1">{{ item.label }}</div>
			</div>
			<div
				v-if="item.children"
				class="mt-35 layout-footer-sub"
				:class="[footerExpand[item.expand] ? 'layout-footer-sub--expand' : 'layout-footer-sub--collapse']"
			>
				<span
					v-for="(child, _index) in item.children"
					:key="_index"
					class="layout-footer-level--2"
					@click="goMenu(child.name, child.id)"
					>·{{ child.label }}</span
				>
			</div>
		</div>
		<div class="layout-footer-item">
			<div class="layout-footer-qrcode-wrap">
				<div>
					<img src="@/assets/images/qrcode.jpg" alt="" class="layout-footer-qrcode" />
					<div class="mt-8 layout-footer-tips">Aidite微信公众号</div>
				</div>
				<div>
					<img src="@/assets/images/qrcode_miniapp.png" alt="" class="layout-footer-qrcode" />
					<div class="mt-8 layout-footer-tips">爱迪特投关</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { MENU } from '@/utils/const';
import { ref } from 'vue';
import { useRouter } from '@/utils/api';

defineProps({
	scale: {
		type: Number,
		default: 1
	}
});

const footerExpand = ref({
	'business': false,
	'investment': false,
	'finance': false,
	'serve': false
});

const router = useRouter();
const goMenu = (name, id = null) => {
	router.push({
		name: name,
		hash: id ? `#${id}` : ''
	});
	//公司治理滚动到
	setTimeout(() => {
		let dom = document.querySelector(`#${id}`);
		if (!dom) return;
		window.scrollTo({
			top: dom.offsetTop,
			behavior: 'smooth'
		});
	}, 200);
};
const goAiditeIndex = () => {
	window.location.href = 'https://www.aidite.com';
};
</script>

<style lang="less" scoped>
.layout-footer-wrap {
	padding: 48px 0;
	display: flex;
	justify-content: space-between;

	.layout-footer-logo {
		width: 120px;
		height: 30px;
		cursor: pointer;
	}
	.layout-footer-item {
		font-size: 0;
	}
	.layout-footer-level--1 {
		color: #fff;
		font-family: 'SourceHanSansCN-Normal';
		font-size: 0.9rem;
		font-style: normal;
		font-weight: 500;
		cursor: pointer;
	}
	.layout-footer-level--2 {
		display: block;
		color: #fff;
		font-family: 'SourceHanSansCN-Normal';
		font-size: 0.9rem;
		font-style: normal;
		font-weight: 400;
		cursor: pointer;

		& + .layout-footer-level--2 {
			margin-top: 14px;
		}
	}

	.layout-footer-qrcode-wrap {
		display: flex;
		flex-direction: column;
		gap: 20px;
	}
	.layout-footer-qrcode {
		width: 90px;
		height: 90px;
	}
	.layout-footer-tips {
		text-align: center;
		color: #fff;
		font-family: 'SourceHanSansCN-Normal';
		font-size: 12px;
		font-style: normal;
		font-weight: 400;
		line-height: 140%; /* 16.8px */
	}
	.layout-footer-sub--expand {
		visibility: visible;
	}
	.layout-footer-sub--collapse {
		visibility: hidden;
	}

	.layout-footer-sub {
		position: absolute;
		left:0;
		width: max-content;
        min-width: 100%;

	}
}
</style>
